import React, { useState, useEffect, useRef } from "react";
import { CommentaryWidgetContainer } from "./style.js";
import Loader from "@/shared/Loader/index.js";

const CommentaryWidget = ({ match }) => {
    const [commentaryData, setCommentaryData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [uuidMatch, setUuidMatch] = useState();
    const intervalRef = useRef(null);

    const mapId = async () => {
        try {
            const queryParams = new URLSearchParams({
                entityType: "fixture",
                idList: match,
            }).toString();
            const response = await fetch(`/api/estadisticasFutbol/mapping-id/${queryParams}`);
            const { data } = await response.json();
            return data?.mapping?.[0]?.uuid;
        } catch (e) {
            console.error("Error al mapear ID:", e);
            return null;
        }
    };

    const getCommentary = async (matchId) => {
        if (!matchId) return;
        try {
            const response = await fetch(`/api/estadisticasFutbol/match-commentary/?matchId=${matchId}`);
            const responseData = await response.json();
            setIsLoading(false);
            if (!responseData?.error && responseData?.code === 200 && responseData?.data)
                return responseData.data;
        } catch (e) {
            console.error("Error al traer comentarios:", e);
            return null;
        }
    };

    const fetchCommentary = async () => {
        if (!match) return;
        let uuid = uuidMatch;
        if (!uuidMatch) {
            uuid = await mapId();
            setUuidMatch(uuid);
        }

        if (uuid) {
            const matchCommentary = await getCommentary(uuid);
            setCommentaryData(matchCommentary);

            const messages = matchCommentary?.messages?.[0]?.message || [];
            const lastEvent = messages[0];

            if (lastEvent?.type === "end 14") {
                console.log("El partido terminó. Deteniendo actualizaciones automáticas.");
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }
    };

    useEffect(() => {
        const init = async () => {
            await fetchCommentary();

            if (!intervalRef.current) {
                intervalRef.current = setInterval(() => {
                    fetchCommentary();
                }, 20000);
            }
        };

        init();

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [match]);

    const eventIcons = {
        goal: {
            label: "Gol",
            icon: "https://www.clarin.com/images/collections/mam-commentary/ball-icon___68090191045a4c001b017d0e.png",
            width: 20,
            height: 20
        },
        "red card": {
            label: "Tarjeta roja",
            icon: "https://www.clarin.com/images/collections/mam-commentary/red-card-icon___680901919cefe90018f396bb.png",
            width: 18,
            height: 24
        },
        "yellow card": {
            label: "Tarjeta amarilla",
            icon: "https://www.clarin.com/images/collections/mam-commentary/yellow-card___6808f6289cefe90018f396ba.png",
            width: 18,
            height: 24
        },
        corner: {
            label: "Corner",
            icon: "https://www.clarin.com/images/collections/mam-commentary/corner-icon___680901919cefe90018f396bc.png",
            width: 24,
            height: 24
        },
        substitution: {
            label: "Cambio",
            icon: "https://www.clarin.com/images/collections/mam-commentary/change-icon___68090192045a4c001b017d10.png",
            width: 16,
            height: 16
        },
        start: {
            label: "Inicio del partido",
            icon: "https://www.clarin.com/images/collections/mam-commentary/whistle-icon___68090191045a4c001b017d0f.png",
            width: 21,
            height: 21
        },
        secondStart: {
            label: "Inicia el segundo tiempo",
            icon: "https://www.clarin.com/images/collections/mam-commentary/whistle-icon___68090191045a4c001b017d0f.png",
            width: 21,
            height: 21
        },
        "contentious referee decisions": {
            label: "Decisión del VAR",
            icon: "https://www.clarin.com/images/collections/mam-commentary/var-icon___68090190045a4c001b017d0d.png",
            width: 18,
            height: 18
        },
        "end 1": {
            label: "Final primera parte",
            icon: "https://www.clarin.com/images/collections/mam-commentary/whistle-icon___68090191045a4c001b017d0f.png",
            width: 21,
            height: 21
        },
        "end 2": {
            label: "Final segunda parte",
            icon: "https://www.clarin.com/images/collections/mam-commentary/whistle-icon___68090191045a4c001b017d0f.png",
            width: 21,
            height: 21
        },
        "end 14": {
            label: "Fin del partido",
            icon: "https://www.clarin.com/images/collections/mam-commentary/whistle-icon___68090191045a4c001b017d0f.png",
            width: 21,
            height: 21
        },
    };
    return (
        <CommentaryWidgetContainer>
            <hr />
            <h2 className="commentary-title">Relato |<span>Minuto a minuto</span></h2>
            <section className="timeline" aria-label="Lista de eventos del partido">
                {!isLoading ?
                    commentaryData?.messages?.[0]?.message?.length ?
                        commentaryData?.messages?.[0]?.message?.filter((commentary) =>
                            !["free kick lost", "free kick won", "end delay", "start delay"].includes(commentary.type)
                        )?.map((commentary, index) => {
                            console.log(commentary, 'commentary')
                            const highlight = commentary.type === "goal";
                            const type = commentary.type == "start" && commentary.period == 1 ? "start" :
                                commentary.type == "start" && commentary.period == 2 ? "secondStart" : commentary.type;
                            return (
                                <article
                                    key={index}
                                    className={`comment ${highlight ? "highlight" : ""}`}
                                    aria-label={`Evento en el minuto ${commentary.time}: ${commentary.comment}`}
                                >
                                    {highlight && (<div className="highlight-overlay"></div>)}
                                    {(commentary.time?.trim() || eventIcons[commentary.type]) && (
                                        <div className="time-group">
                                            <span className="minute">{commentary.time}</span>
                                            {eventIcons[commentary.type] && (
                                                <>
                                                    {/* {commentary.time?.trim() && " - "} */}
                                                    <img
                                                        className="event-image"
                                                        src={eventIcons[commentary.type].icon}
                                                        alt={eventIcons[commentary.type].label}
                                                        width={eventIcons[commentary.type].width}
                                                        height={eventIcons[commentary.type].height}
                                                    />
                                                    <span className="event-name">{eventIcons[type].label}</span>
                                                </>
                                            )}
                                        </div>
                                    )}
                                    <span className="event-detail">
                                        {commentary.comment}
                                    </span>
                                </article>
                            );
                        })
                        :
                        <span className="comment">No hay datos disponibles.</span>
                    :
                    <Loader />
                }
            </section>
        </CommentaryWidgetContainer>
    );
};

export default CommentaryWidget;